import type { FirestoreUserSearch } from '../firestore/UserSearch'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { PublicUser } from '../models/PublicUser'

export class UserSearch {
  repository: FirebaseRepository
  id: string

  data: FirestoreUserSearch

  publicUser: PublicUser

  constructor(
    repository: FirebaseRepository,
    id: string,
    data: FirestoreUserSearch
  ) {
    this.repository = repository
    this.id = id
    this.data = data
    this.publicUser = PublicUser.empty(repository).replaceData(data)
  }

  get fullName(): string {
    return `${this.data.firstNameCased} ${this.data.lastNameCased}`.trim()
  }
}
